export default __webpack_public_path__ + "static/media/pups-logo-banner-grande.5b244ae2.png";